// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3Qull","fileBtn":"File_fileBtn__1oQGx","closeBtn":"File_closeBtn__3n8ud","fileSelected":"File_fileSelected__bI6t8","disabled":"File_disabled__bscLR"};